module.exports = __webpack_public_path__ + "img/phone.926fe9a7.svg";